export type CurriculumPreviewParams = {
  countryCode: string,
  regionCode: string,
};

export type CourseTypeExtension = {
  courseId: string;
};

export type GoalIdTypeExtension = {
  goalId: string,
};

export const CURRICULUM_PREVIEW_ROUTE = {
  name: 'curriculumpreview/:countryCode/:regionCode',
  route(params: CurriculumPreviewParams): string[] {
    return ['/curriculumpreview', params.countryCode, params.regionCode];
  },
  DEFAULT: '',
  PREVIEW_COURSE: {
    name: ':courseId',
    route(params: CurriculumPreviewParams & CourseTypeExtension): string[] {
      return [...CURRICULUM_PREVIEW_ROUTE.route(params), params.courseId];
    },
    PREVIEW_GOAL: {
      name: ':goalId',
      route(params: CurriculumPreviewParams & CourseTypeExtension & GoalIdTypeExtension ): string[] {
        return [...CURRICULUM_PREVIEW_ROUTE.PREVIEW_COURSE.route(params), params.goalId];
      },
    }
  }
}
